import { Box } from "@mui/material";
import { CheckboxList } from "@platform/design-system";

import { useRowVisibility } from "./rowVisibility";

export const RowsPanel = (): React.JSX.Element => {
  const { rows, hiddenRowGroupIds, toggleRowGroup } = useRowVisibility();

  const items = rows.map((row) => ({
    id: row.id,
    label: row.label,
    checked: !hiddenRowGroupIds.has(row.id),
  }));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <CheckboxList items={items} onToggle={toggleRowGroup} />
      </Box>
    </Box>
  );
};
